import {
  DynamicEnergyContract,
  EnergyProviderContractInput,
  FixedEnergyContract,
} from "../services/client";

export const isFixed = (
  contract: EnergyProviderContractInput | null | undefined,
): contract is FixedEnergyContract => {
  return contract?.contract_type === "fixed";
};

export const isDynamic = (
  contract: EnergyProviderContractInput | null | undefined,
): contract is DynamicEnergyContract => {
  return contract?.contract_type === "dynamic";
};
